<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="aiAgent.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Модель</label>
            <crm-input-text
              [(value)]="aiAgent.model"
              [isError]="$any(errors?.model)"></crm-input-text>
            <small
              *ngIf="errors?.model"
              class="p-error">
              {{ errors.model | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Тип</label>
            <crm-single-select
              [options]="types"
              [(selectedItem)]="aiAgent.type"
              [class]="errors?.type ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.type ? 'ng-invalid ng-dirty' : ''"
              [filter]="false"
              [isTemplateCombined]="true"
              optionValue="name"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-type="item">
                {{ type.value | agentTypeName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.type"
              class="p-error">
              {{ errors.type | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Режим работы</label>
            <crm-single-select
              [options]="operatingModes"
              [(selectedItem)]="aiAgent.operatingMode"
              [class]="errors?.operatingMode ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.operatingMode ? 'ng-invalid ng-dirty' : ''"
              [filter]="false"
              [isTemplateCombined]="true"
              optionValue="name"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-mode="item">
                {{ mode.value | agentOperatingModeName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.operatingMode"
              class="p-error">
              {{ errors.operatingMode | join }}
            </small>
          </div>

          <div
            *ngIf="needSearchCategories"
            class="field">
            <label class="font-medium">Категории поиска</label>
            <crm-enum-values-multi-select
              [options]="searchCategoriesOptions"
              [(selectedValues)]="aiAgent.searchCategories"
              [isError]="!!errors?.searchCategories"
              appendTo="body"
              placeholder="Выберите категории"></crm-enum-values-multi-select>
            <small
              *ngIf="errors?.searchCategories"
              class="p-error">
              {{ errors.searchCategories | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Инструкции</label>
            <textarea
              pInputTextarea
              [(ngModel)]="aiAgent.prompt"
              rows="10"
              [autoResize]="false"></textarea>
            <small
              *ngIf="errors?.prompt"
              class="p-error">
              {{ errors.prompt | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">API ключ</label>
            <crm-input-text
              [(value)]="aiAgent.apiKey"
              [isError]="$any(errors?.apiKey)"></crm-input-text>
            <small
              *ngIf="errors?.apiKey"
              class="p-error">
              {{ errors.apiKey | join }}
            </small>
          </div>

          <div
            *ngIf="needFolderID()"
            class="field">
            <label class="font-medium">FolderID</label>
            <crm-input-text
              [(value)]="aiAgent.folderID"
              [isError]="$any(errors?.folderID)"></crm-input-text>
            <small
              *ngIf="errors?.folderID"
              class="p-error">
              {{ errors.folderID | join }}
            </small>
          </div>

          <div
            *ngIf="needBaseURL()"
            class="field">
            <label class="font-medium required-field">Базовый URL (обязательно для типа OpenAI)</label>
            <crm-input-text
              [(value)]="aiAgent.baseURL"
              [isError]="$any(errors?.baseURL)"></crm-input-text>
            <small
              *ngIf="errors?.baseURL"
              class="p-error">
              {{ errors.baseURL | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Степень случайности и креативности</label>
            <div class="flex align-items-center">
              <p-slider
                class="w-full"
                [(ngModel)]="aiAgent.temperature"
                [min]="0"
                [max]="1"
                [step]="0.1"></p-slider>
              <div class="ml-3 frm-color-blue">{{ aiAgent.temperature || 0.7 }}</div>
            </div>
          </div>

          <div class="field">
            <label class="font-medium required-field">Минимальная надежность ответов</label>
            <div class="flex align-items-center">
              <p-slider
                class="w-full"
                [(ngModel)]="aiAgent.minConfidence"
                [min]="0"
                [max]="1"
                [step]="0.1"></p-slider>
              <div class="ml-3 frm-color-blue">{{ aiAgent.minConfidence || 0.7 }}</div>
            </div>
          </div>

          <div class="field-checkbox">
            <p-checkbox
              [(ngModel)]="aiAgent.isActive"
              [binary]="true"
              inputId="isActive"></p-checkbox>
            <label [for]="'isActive'">Активный</label>
          </div>

          <div class="flex flex-column">
            <div class="field-checkbox" [ngClass]="{ 'mb-0': errors?.isEmbedding }">
              <p-checkbox
                [(ngModel)]="aiAgent.isEmbedding"
                [binary]="true"
                inputId="isEmbedding"
                (ngModelChange)="onIsEmbeddingChange($event)">
              </p-checkbox>
              <label [for]="'isEmbedding'">Умеет работать с вектором</label>
            </div>
            <small
              *ngIf="errors?.isEmbedding"
              class="p-error my-1">
              {{ errors.isEmbedding | join }}
            </small>
          </div>

          <div class="flex flex-column">
            <div class="field-checkbox" [ngClass]="{ 'mb-0': errors?.isEmbeddingDefault }">
              <p-checkbox
                [(ngModel)]="aiAgent.isEmbeddingDefault"
                [binary]="true"
                [disabled]="!aiAgent.isEmbedding"
                inputId="isEmbeddingDefault">
              </p-checkbox>
              <label [for]="'isEmbeddingDefault'">Дефолтный агент для эмбеддинга и поиска в базе знаний</label>
            </div>
            <small
              *ngIf="errors?.isEmbeddingDefault"
              class="p-error my-1">
              {{ errors.isEmbeddingDefault | join }}
            </small>
          </div>

          <div class="field-checkbox">
            <p-checkbox
              [(ngModel)]="aiAgent.autoReply"
              [binary]="true"
              inputId="autoReply"></p-checkbox>
            <label [for]="'autoReply'">Автоматический ответ</label>
          </div>

          <div class="field-checkbox">
            <p-checkbox
              [(ngModel)]="aiAgent.isVoiceAssistantDefault"
              [binary]="true"
              inputId="isVoiceAssistantDefault"></p-checkbox>
            <label [for]="'isVoiceAssistantDefault'">Используется голосовым помощником</label>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveAgent()"></crm-button>
      <div class="flex align-items-center gap-2">
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && !aiAgent['deleted']"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteAgent()"></crm-button>
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && aiAgent['deleted']"
          icon="pi pi-undo"
          label="Восстановить"
          styleClass="p-button-info p-button-text"
          (onClick)="restoreAgent()"></crm-button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
